import { createApp } from 'vue';
import App from '../../account/src/App.vue';
import '../../account/src/styles.css';
import '../../account/src/party-theme.css';
import '../../account/src/motion.css';
createApp(App).mount('#app');
